import { useEffect, useState } from "react"

export const useFileMech3DModelWorkerController = () => {
  const [worker, setWorker] = useState<Worker | null>(null)

  useEffect(() => {
    const newWorker = new Worker(
      new URL("./getFileMech3DModelWorker.ts", import.meta.url)
    )

    setWorker(newWorker)

    // Cleanup worker on component unmount
    return () => newWorker.terminate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    workerFileMech3D: worker,
  }
}
